module.exports = __webpack_public_path__ + "img/tss-4.5e68acb3.jpg";